// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"151":"98bb4ac4","446":"acd0e76c","481":"daba5d63","541":"9fc46fac","585":"18fb86c9","701":"cb8a73c1","781":"cb8a73c1"}[chunkId] + ".chunk.css";
};